import {useContext} from 'react'
import {UserNameDisplayContext} from './UserNameDisplayContext'

export interface ProfileReferenceProps {
  login: string
  profileName?: string | null
}

export function ProfileReference({login, profileName}: ProfileReferenceProps) {
  const displayMode = useContext(UserNameDisplayContext)

  if (displayMode === 'name_handle' && profileName?.trim()) {
    return (
      <>
        {profileName} ({login})
      </>
    )
  }

  // displayMode === 'handle'
  return <>{login}</>
}

try{ ProfileReference.displayName ||= 'ProfileReference' } catch {}